import React, { useLayoutEffect } from 'react';
import GoUpBtn from '../../common/GoUpBtn';
import Loader from '../../common/Loader';
import PrematchContext from '../../contexts/PrematchContext';
import { ReactComponent as CloseIcon } from '../../icons/menu.svg';
import { ReactComponent as PrintIcon } from '../../icons/print.svg';
import { getLabel } from '../../data/labels';
import { adjustOddsAlignment } from '../../tables-utils';
import { PrematchDataContext } from '../PrematchDataFetcher';
import Events from './Events';
import { getConfiguration } from '../../data/utils';
import { useFetch } from '../../data/fetch/useFetch';
import { parseExtraEvents } from '../../data/parseExtraEvent';

export default function ExtraEvents() {
    const conf = getConfiguration();
    const prematchContext = React.useContext(PrematchContext);
    const prematchData = React.useContext(PrematchDataContext);

    const [isLoading, isError, data] = useFetch(conf.api.getExtraEvents, null, (data) =>
        parseExtraEvents(prematchData, data)
    );

    useLayoutEffect(() => {
        adjustOddsAlignment();
    });

    if (isLoading || isError) {
        return <Loader isError={isError} />
    }

    function handleClose() {
        prematchContext.closeAllTournaments();
    }

    return (
        <div className="griglia-centrale-sport col stringimento-sidebar sb-1" id="xs-favorite-odds">
            <div className="contenitore-schedine-sport">
                <div className="competizione-interna dueColonne dueColonne_Template_1 unaColonna">
                    <div id="primo-blocco-sport" className="sport-blocco primo-blocco-sport go-up-arrow-on-overflow no-margin tablesExpanded">
                        <GoUpBtn />
                        <div className="titolo-blocco-sport bg-nero bianco pointer">
                            <i className="fa fa-times margine-dx align-self-center" onClick={handleClose}></i>
                            <div className="nome-competizione-sport">
                                <span className="grassetto">{[getLabel('prematch.extra_events.title')]}</span>
                            </div>
                            <div className="icone-controllo-sport-centrale">
                                <PrintIcon
                                    className="margine-dx pointer"
                                    onClick={() => prematchContext.openPrintExtraOdds(data.raw)}
                                    data-desc={getLabel('prematch_page.control_icon.print')}
                                />
                                <CloseIcon className="pointer" onClick={handleClose} />
                            </div>
                        </div>
                        {isLoading || isError ?
                            <Loader error={isError} />
                            :
                            <>
                                <Events items={data.cota} cota={true} title={getLabel('prematch.extra_events.cota')} />
                                <Events items={data.extra} extra={true} title={getLabel('prematch.extra_events.extra')} />
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
